<template>
  <div class="invoice-dense-tab">
    <div class="invoice-dense-table-wrap">
      <b-table
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        hover
        responsive
        small
        :busy="loading"
        show-empty
        class="invoice-dense-table mb-0"
      >
        <template #table-busy>
          <div class="invoice-dense-state invoice-dense-state--loading">
            <b-spinner small class="mr-50" />
            <span>Loading invoices…</span>
          </div>
        </template>
        <template #empty>
          <div class="invoice-dense-state">
            <div class="invoice-dense-empty-icon">
              <feather-icon icon="FileTextIcon" size="28" />
            </div>
            <h6 class="mb-25">No invoices found</h6>
            <p class="text-muted mb-1">
              {{ searchActive ? 'Try a different search or clear it.' : 'Adjust date range or filters to load invoices.' }}
            </p>
            <b-button v-if="searchActive" size="sm" variant="outline-secondary" @click="$emit('clear-search')">
              Clear search
            </b-button>
          </div>
        </template>
        <template #cell(invoice_id)="{ item }">
          <div class="inv-cell-stack">
            <span class="inv-primary-text text-nowrap">{{ item.invoice_id || 'N/A' }}</span>
            <small class="text-muted text-nowrap">{{ formatDate(item.invoice_date) || 'N/A' }}</small>
          </div>
        </template>
        <template #cell(status)="{ item }">
          <b-badge :variant="getStatusVariant(item.status)" class="inv-status-badge">{{ item.status || '—' }}</b-badge>
        </template>
        <template #cell(total_amount)="{ item }">
          <span class="inv-amount">₹{{ formatIndianNumber(item.total_amount) }}</span>
        </template>
        <template #cell(booking_status)="{ item }">
          <b-badge :variant="getBookingStatusVariant(item.booking_status)" class="inv-status-badge">
            {{ item.booking_status || 'Pending' }}
          </b-badge>
        </template>
        <template #cell(actions)="{ item }">
          <div class="inv-row-actions">
            <b-button
              variant="outline-primary"
              size="sm"
              class="mr-50"
              @click="$emit('view-invoice', item)"
            >
              View
            </b-button>
            <b-button
              v-if="item.booking_status === null || item.booking_status === 'Pending'"
              variant="outline-warning"
              size="sm"
              @click="$emit('update-booking', item)"
            >
              Book
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <div v-if="totalRows > perPage" class="invoice-dense-pagination">
      <b-pagination
        :value="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="sm"
        @change="$emit('page-change', $event)"
      />
    </div>
  </div>
</template>

<script>
import { BTable, BBadge, BButton, BSpinner, BPagination } from 'bootstrap-vue'
import invoiceFormatMixin from '@/mixins/invoiceFormatMixin'

export default {
  name: 'ReconInvoiceOverviewTab',
  components: { BTable, BBadge, BButton, BSpinner, BPagination },
  mixins: [invoiceFormatMixin],
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    totalRows: { type: Number, default: 0 },
    searchActive: { type: Boolean, default: false }
  },
  emits: ['view-invoice', 'update-booking', 'page-change', 'clear-search'],
  methods: {
    getBookingStatusVariant(status) {
      const map = { Booked: 'success', 'Not Booked': 'danger', Pending: 'warning' }
      return map[status] || 'secondary'
    }
  }
}
</script>

<style lang="scss">
@import '../tabs/invoice-dense-tab.scss';
</style>
